export default "__VITE_ASSET__CDkPgVss__"